import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectAll", "checkbox", "submitBtn", "count"];

  selectAllChanged() {
    const checked = this.selectAllTarget.checked;
    this.checkboxTargets.forEach((cb) => (cb.checked = checked));
    this.update();
  }

  checkboxChanged() {
    this.update();
  }

  update() {
    const checked = this.checkboxTargets.filter((cb) => cb.checked);
    this.submitBtnTargets.forEach(
      (btn) => (btn.disabled = checked.length === 0),
    );
    if (this.hasCountTarget) {
      this.countTarget.textContent = checked.length;
    }
  }
}
